/**
 * Configuration data collected through the wizard
 */
export interface WizardConfig {
  // Step 1: Agent Info
  agentName: string
  email: string
  phone: string

  // Step 2: Calendly
  calendlyUrl: string

  // Step 3: Market Settings
  cities: string[]
  priceRanges: string[]

  // Step 4: Branding
  primaryColor: string
  botNamePreference: string

  // Generated
  clientId: string
}

/**
 * Validation errors for wizard steps
 */
export interface WizardErrors {
  agentName?: string
  email?: string
  phone?: string
  calendlyUrl?: string
  cities?: string
  priceRanges?: string
  primaryColor?: string
}

/**
 * Wizard step information
 */
export interface WizardStep {
  number: number
  title: string
  description: string
}

export const WIZARD_STEPS: WizardStep[] = [
  {
    number: 1,
    title: 'Agent Info',
    description: 'Tell us about yourself',
  },
  {
    number: 2,
    title: 'Calendly',
    description: 'Connect your scheduling',
  },
  {
    number: 3,
    title: 'Market',
    description: 'Configure your market',
  },
  {
    number: 4,
    title: 'Branding',
    description: 'Customize your bot',
  },
  {
    number: 5,
    title: 'Review',
    description: 'Confirm & checkout',
  },
]
